var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThrash2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9082 9L18.1923 18.3068C18.032 20.3908 16.2942 22 14.2041 22H9.61233C7.52218 22 5.78442 20.3908 5.62411 18.3068L4.9082 9M20.9082 7C18.3103 5.73398 15.2219 5 11.9082 5C8.59455 5 5.50612 5.73398 2.9082 7M9.9082 5V4C9.9082 2.89543 10.8036 2 11.9082 2C13.0128 2 13.9082 2.89543 13.9082 4V5M9.9082 11V17M13.9082 11V17",
    stroke: "#EF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrash2);
export default __webpack_public_path__ + "static/media/thrash-2.c7558f80.svg";
export { ForwardRef as ReactComponent };